var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRcf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 576,
    height: 576,
    viewBox: "0 0 576 576",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 287.88,
    cy: 287.88,
    r: 287.88,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.08 160.212C128.08 150.473 136.03 142.606 145.869 142.606H186.395C201.682 142.606 215.302 152.289 220.138 166.704L271.337 318.662C288.07 318.937 302.912 326.859 312.474 339.018L424.822 301.936C434.161 298.855 444.223 303.862 447.336 313.05C450.449 322.238 445.391 332.251 436.107 335.332L323.759 372.414C323.258 401.133 299.577 424.295 270.392 424.295C240.929 424.295 217.025 400.638 217.025 371.478C217.025 354.533 225.085 339.458 237.593 329.775L186.395 177.817H145.869C136.03 177.817 128.08 169.95 128.08 160.212ZM264.166 216.604C261.108 207.361 266.222 197.403 275.562 194.432L300.967 186.29L311.973 219.795L345.828 208.902L334.766 175.396L360.17 167.254C369.51 164.228 379.571 169.289 382.573 178.532L410.035 262.269C413.093 271.512 407.978 281.47 398.639 284.441L314.03 311.619C304.691 314.645 294.629 309.584 291.627 300.341L264.166 216.604Z",
    fill: "#FA0073"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRcf);
export default __webpack_public_path__ + "static/media/rcf.5713e7d31dd3ec613d737163e4f33196.svg";
export { ForwardRef as ReactComponent };